import type { LobbyPlayer } from '@big2/shared';

/** Players placed at their table seat (index = seat); `null` is an empty seat. Seatless players fill gaps in order. */
export function arrangeLobbySeats(players: LobbyPlayer[], seats: number): (LobbyPlayer | null)[] {
  const slots: (LobbyPlayer | null)[] = Array.from({ length: seats }, () => null);
  const unplaced: LobbyPlayer[] = [];
  for (const player of players) {
    const seat = player.seat;
    if (typeof seat === 'number' && seat >= 0 && seat < seats && !slots[seat]) slots[seat] = player;
    else unplaced.push(player);
  }
  for (const player of unplaced) {
    const free = slots.indexOf(null);
    if (free < 0) break;
    slots[free] = player;
  }
  return slots;
}
